import React, { useEffect, useCallback } from 'react';
import { useAppStore } from '../../store/appStore';
import { cameraApi, notificationApi } from '../../services/api';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import CamerasPanel from '../views/CamerasPanel';
import CameraView from '../camera/CameraView';
import AuditPanel from '../views/AuditPanel';
import EventsPanel from '../views/EventsPanel';
import SettingsPanel from '../views/SettingsPanel';
import NotificationsPanel from '../views/NotificationsPanel';
import SchedulePanel from '../views/SchedulePanel';

export default function AppShell() {
  const { setCameras, setGroups, activePanel, selectedCamera, addToast, setUnreadNotifications } = useAppStore();

  const loadCameras = useCallback(async () => {
    try {
      const [camRes, grpRes] = await Promise.all([
        cameraApi.list(),
        cameraApi.listGroups(),
      ]);
      setCameras(camRes.data);
      setGroups(grpRes.data);
    } catch (err) {
      addToast({ type: 'error', message: 'Failed to load cameras' });
    }
  }, []);

  useEffect(() => {
    loadCameras();
    const interval = setInterval(loadCameras, 30000); // Refresh every 30s
    return () => clearInterval(interval);
  }, [loadCameras]);

  // Poll the unread notification count for the badge.
  const loadUnread = useCallback(async () => {
    try {
      const res = await notificationApi.list();
      setUnreadNotifications(res.data.unreadCount || 0);
    } catch { /* non-fatal */ }
  }, [setUnreadNotifications]);

  useEffect(() => {
    loadUnread();
    const interval = setInterval(loadUnread, 60000); // Refresh every 60s
    return () => clearInterval(interval);
  }, [loadUnread]);

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden', background: 'var(--bg-void)' }}>
      <Sidebar />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', minWidth: 0 }}>
        <TopBar />
        <div style={{ flex: 1, overflow: 'hidden', display: 'flex' }}>
          {activePanel === 'cameras' && (
            <div style={{ display: 'flex', width: '100%', overflow: 'hidden' }}>
              {selectedCamera
                ? <CameraView camera={selectedCamera} onRefresh={loadCameras} />
                : <CamerasPanel onRefresh={loadCameras} />
              }
            </div>
          )}
          {activePanel === 'audit' && <AuditPanel />}
          {activePanel === 'events' && <EventsPanel />}
          {activePanel === 'notifications' && <NotificationsPanel />}
          {activePanel === 'schedule' && <SchedulePanel />}
          {['account', 'users', 'companies', 'system'].includes(activePanel) && <SettingsPanel section={activePanel} />}
        </div>
      </div>
    </div>
  );
}
